// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// import { getAnalytics, logEvent } from "firebase/analytics";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseConfig = {
  apiKey: "AIzaSyBv2D2gLMzM-wvQMiVCKyTCW6xQPNsJINk",
  authDomain: "amrita-live.firebaseapp.com",
  projectId: "amrita-live",
  storageBucket: "amrita-live.appspot.com",
  messagingSenderId: "820316952394",
  appId: "1:820316952394:web:db1036c9976c4f2896d3b3",
  measurementId: "G-KD91QZJXX1"
};

// Initialize Firebase
 export const firebaseAnalytics = initializeApp(firebaseConfig);
// const analytics = getAnalytics(firebaseAnalytics);